// extracted by mini-css-extract-plugin
export default {"container":"PriceBook_container__po2EQ","body":"PriceBook_body__PwUj5"};